import { ca } from '@cian/analytics';

import { getCustomUrl } from './getCustomUrl';
import { getPage } from './getPage';
import { getProduct } from './getProduct';
import { getUser } from './getUser';
import { getProducts } from './get_products';
import { IAgentSchema, IOfferSchema, IUserSchema } from '../../types/api-models/offer-card/v1/get-offer-data';

interface ITrackEarlyAccessPhoneClick {
  source: string;
  offer: IOfferSchema;
  agent: IAgentSchema | null;
  user: IUserSchema | null;
  siteBlockId?: number | null;
}

interface ITrackBlockedEarlyAccessPhoneClick extends ITrackEarlyAccessPhoneClick {
  blockedType: string;
}

interface ITrackEarlyAccessChatClick {
  offer: IOfferSchema;
  agent: IAgentSchema | null;
  blockType: string;
}

export function trackShowEarlyAccessPhoneClick({
  source,
  offer,
  agent,
  user,
  siteBlockId,
}: ITrackEarlyAccessPhoneClick) {
  const products = getProducts({ agent, offer, kpId: null, siteBlockId });
  const basePage = getPage(agent, offer, siteBlockId);

  ca('eventEbc', {
    action: `Open_${source}_early_access`,
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    page: {
      ...basePage,
      extra: {
        ...basePage.extra,
        earlyAccess: true,
      },
    },
    products: [
      {
        ...products,
        variant: products.variant ? products.variant.split('/') : [],
      },
    ],
    user: getUser(user, 0),
  });
}

export function trackBlockedEarlyAccessPhoneClick({
  source,
  blockedType,
  offer,
  agent,
  user,
  siteBlockId,
}: ITrackBlockedEarlyAccessPhoneClick) {
  const products = getProducts({ agent, offer, kpId: null, siteBlockId });
  const basePage = getPage(agent, offer, siteBlockId);

  ca('eventEbc', {
    action: `Blocked_${source}_early_access`,
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    page: {
      ...basePage,
      extra: {
        ...basePage.extra,
        block_type: blockedType,
      },
    },
    products: [
      {
        ...products,
        variant: products.variant ? products.variant.split('/') : [],
      },
    ],
    user: getUser(user, 0),
  });
}

export function trackBlockedEarlyAccessChatClick({ offer, agent, blockType }: ITrackEarlyAccessChatClick) {
  const products = getProduct(offer, agent);

  ca('eventSite', {
    action: 'send_message_blocked_early_access',
    category: 'card',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
    page: {
      pageType: 'Card',
      siteType: 'desktop',
      extra: {
        owner_id: offer.userId,
        block_type: blockType,
      },
    },
    user: getUser(null, 0),
  });
}
